import NoMoneyIcon from '@/assets/icons/no-money.svg?react'

export const UnstakeEmptyState = ({ isLoading = false }: { isLoading?: boolean }) => {
  return (
    <div className="text-gray-90 mb-14 flex grow flex-col items-center justify-center gap-2">
         <NoMoneyIcon className="mx-auto h-[104px] w-[104px]" />
      <p className="text-body-2">{isLoading ? 'Loading...' : 'There is nothing to unstake or withdraw.'}</p>
    </div>
  )
}
